import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "swiper/swiper-bundle.css";

import "./ClientSwiper.css";
SwiperCore.use([Navigation, Pagination, Autoplay]);
const ClientSwiper = () => {
    const customPrevButton = (
        <IoIosArrowBack size={30} color="#333" className="swiper-button-prev" />
    );

    const customNextButton = (
        <IoIosArrowForward size={30} color="#333" className="swiper-button-next" />
    );

    return (
        <Swiper
            navigation={{
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
            }}
            pagination={{ clickable: true }}
            loop
            speed={1000}
            autoplay={{ delay: 1000 }} // Set autoplay delay to 1 second
            className="swiper2 p-8 my-4"
        >
   

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-base mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                    "אין לי מילים שיכולות לתאר את הזוהר שיש לי בפנים ואת הרכות שבהם ואת הברק!!!! פשוט וואו אלופה אין לי מילים תודה רבה רבה נהנתי מאוד ❤️❤️❤️❤️❤️❤️"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    ספיר
                </p>
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-base mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                    "היי בדיוק התקלחתי, יצא מושלם.
                    תודה רבה היה מדהיםםםם!! את אלופה ויש לך ידיים ולב זהב והפנים מרגישות כמו משי
                    מאמינה שאחרי שירד קצת האדמומיות יהיה מושלם וכמובן אני רוצה גם להקשיב לך לגבי השימוש הביתי בפילינג והסרום ❤️❤️

                    לילה טוב 🙏🏽🙏🏽"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    לי
                </p>
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                    "פצצה ממש אהבתי😍 תודה מהממת💋"
                </p>
                {/* <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>

                </p> */}
            </SwiperSlide>





            <div className="swiper-button-prev-custom">{customPrevButton}</div>
            <div className="swiper-button-next-custom">{customNextButton}</div>
        </Swiper>
    );
}

export default ClientSwiper